/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitoredObjectIdList
 */
export interface MonitoredObjectIdList {
    /**
     * 
     * @type {Array<number>}
     * @memberof MonitoredObjectIdList
     */
    monitoredObjects: Array<number>;
}

export function MonitoredObjectIdListFromJSON(json: any): MonitoredObjectIdList {
    return MonitoredObjectIdListFromJSONTyped(json, false);
}

export function MonitoredObjectIdListFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoredObjectIdList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'monitoredObjects': json['monitored_objects'],
    };
}

export function MonitoredObjectIdListToJSON(value?: MonitoredObjectIdList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'monitored_objects': value.monitoredObjects,
    };
}


